import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import type { Theme } from '@material-ui/core/styles';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import type { PublicFaqData } from '@mogul/api-client';
import React from 'react';

import styles from './Faq.module.css';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      /** @ts-expect-error - ts issue */
      fontWeight: theme.typography.fontWeightRegular,
      color: 'white',
    },
  }),
);

interface Props {
  faqData: PublicFaqData[];
}

export const Faq: React.FC<Props> = props => {
  const classes = useStyles();
  const { faqData } = props;

  return (
    <div>
      <div
        className={`${styles.sectionHeader} sm:mx-0 mx-10 fontVanguard font-bold pb-5`}
      >
        Faq
      </div>
      <div>
        {faqData.map((faq, index) => {
          return (
            <Accordion
              key={index}
              style={{ backgroundColor: '#C3565C', color: 'white' }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography
                  className={classes.heading}
                  style={{ display: 'flex' }}
                >
                  {faq.question}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body2">{faq.answer}</Typography>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </div>
    </div>
  );
};
